import { Currency } from 'api'

export const fiatAssetMain: Currency = 'eur'
